import { chainCommands } from 'prosemirror-commands';
import { liftListItem, sinkListItem, splitListItem } from 'prosemirror-schema-list';
import { withLogAction } from '../../../utils/keymap';
import { ListsSpecs, blType, liType, olType } from './ListsSpecs';
import { actions } from './actions';
import { joinPrevList, liftIfCursorIsAtBeginningOfItem, toList } from './commands';
import { ListAction } from './const';
import { ListsInputRulesExtension } from './inputrules';
export { ListNode, blType, liType, olType } from './ListsSpecs';
export const Lists = (builder, opts) => {
    builder.use(ListsSpecs);
    builder.addKeymap(({ schema }) => {
        const { ulKey, olKey } = opts !== null && opts !== void 0 ? opts : {};
        const bindings = {};
        if (ulKey)
            bindings[ulKey] = withLogAction('bulletList', toList(blType(schema)));
        if (olKey)
            bindings[olKey] = withLogAction('orderedList', toList(olType(schema)));
        return Object.assign({ Enter: splitListItem(liType(schema)), Tab: sinkListItem(liType(schema)), 'Shift-Tab': liftListItem(liType(schema)), 'Mod-[': liftListItem(liType(schema)), 'Mod-]': sinkListItem(liType(schema)) }, bindings);
    }, builder.Priority.High);
    builder.addKeymap(() => ({
        Backspace: chainCommands(liftIfCursorIsAtBeginningOfItem, joinPrevList),
    }), builder.Priority.Low);
    builder.use(ListsInputRulesExtension, { bulletListInputRule: opts === null || opts === void 0 ? void 0 : opts.ulInputRules });
    builder
        .addAction(ListAction.ToBulletList, actions.toBulletList)
        .addAction(ListAction.ToOrderedList, actions.toOrderedList)
        .addAction(ListAction.SinkListItem, actions.sinkListItem)
        .addAction(ListAction.LiftListItem, actions.liftListItem);
};
